import { createAction } from 'redux-actions';
import { createRequestActions } from '../utils';
import { COMPUTE_STATS } from './statsTypes';

export const computeStats = createRequestActions(COMPUTE_STATS);
